export default __webpack_public_path__ + "static/media/file.da7c06a2.png";